import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { NavLink } from 'react-router-dom';

import { httpClient, store, asyncActionCreators } from './model/store';
import SocialServices, { FACEBOOK_SERVICE, TWITTER_SERVICE } from '../utils/socialServices';

const MENU_BTN_ID_BASE = 'footerCollapseBtn';
const MENU_BTN_ID = '#' + MENU_BTN_ID_BASE;
const NAVBAR_COLLAPSE_ID_BASE = 'navbar-collapse-2';
const NAVBAR_COLLAPSE_ID = '#' + NAVBAR_COLLAPSE_ID_BASE;

class Footer extends Component {
	constructor() {
		super();

		this.socialServices = new SocialServices({
			onSetProgress: b => {
				console.info(`Main.socialServices.onSetProgress(${b});`);
			},
			httpClient: httpClient,
			config: store.getState().config.social,
		});
	}

	componentWillUnmount() {
		if (this.socialServices) {
			this.socialServices.destroy();
			this.socialServices = null;
		}
	}

	socialClick(service) {
		console.info(`Header.onSocialClick(${service});`);

		switch (service) {
			case FACEBOOK_SERVICE: {
				this.socialServices.socialClick({ message: '', service: FACEBOOK_SERVICE });
				break;
			}
			case TWITTER_SERVICE:
				this.socialServices.socialClick({ message: '', service: TWITTER_SERVICE });
				break;
			default:
				break;
		}
	}

	render() {
		return (
			<div class="row">
				<footer>
					<nav class="navbar navbar-inverse" style={{ visibility: 'hidden' }}>
						<div class="container-fluid navbar-container">
							<div id="navbar" class="navbar-collapse collapse">
								<ul class="nav navbar-nav text-center">
									{/**
									<li><a href="http://womentoknow.hellobeautiful.com" class={''}>W2K 2016</a></li>
									<li><a href="http://facesofstrength.hellobeautiful.com" class={''}>Faces Of Strength</a></li>
									<li><a href="http://hellobeautiful.com" class={''}>HB Home</a></li>
									*/}
								</ul>
							</div>
						</div>
					</nav>
					<p class="text-center">Copyright © 2019 iOneDigital. All Rights Reserved</p>
				</footer>
			</div>
		);
	}
}

Footer.propTypes = {};

export default Footer;



// WEBPACK FOOTER //
// ./src/js/components/footer.js